import * as yup from 'yup'

export const addCategoriesSchema = yup.object({
	name: yup.string().required(),
})
